module.exports = __webpack_public_path__ + "static/media/pod_inactive.2d4711df.svg";